export default "__VITE_ASSET__FLCzqGRQ__"